import { UpdateUebertragAusVorjahr } from '@/domain/mitarbeiter/features/feiertagskonto/features/feiertagskonto/UpdateUebertragAusVorjahr';
import { useFeiertagskonto } from '@/domain/mitarbeiter/features/feiertagskonto/hooks';
import { useYearPickerContext } from '@/domain/mitarbeiter/features/feiertagskonto/shared/YearPickerContext';
import { useStandortContext } from '@/features/standortContext/StandortContext';
import { Body, Card, CardContent, CardDescription, Heading } from '@e2n/ui/v2';
import {
  faArrowRightArrowLeft,
  faCalendarCirclePlus,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

export function FeiertagskontoContent({
  className,
}: {
  className: React.ReactNode;
}) {
  const { t } = useTranslation();
  const { id } = useParams();
  const {
    currentStandort: { id: standortId },
  } = useStandortContext();
  const { zeitraum, year } = useYearPickerContext();
  const { feiertagskonto } = useFeiertagskonto({
    mitarbeiterId: id,
    zeitraum: zeitraum,
    standortId: standortId,
  });
  return (
    <div className="flex gap-4 flex-col">
      <Heading className="flex flex-col justify-between gap-3">
        <div>{t('domain.mitarbeiter.feiertagskonto.title')}</div>
      </Heading>
      <div className={`flex gap-4 justify-between ${className}`}>
        <Card className="p-4 flex-1">
          <CardContent className="flex flex-row gap-3">
            <div className="bg-neutrals-v2-200 w-12 h-12 rounded-xl flex justify-center items-center">
              <FontAwesomeIcon icon={faCalendarCirclePlus} className="size-6" />
            </div>
            <CardDescription className="flex flex-col">
              <Body
                size="sm"
                weight="semibold"
                className="text-labels-secondary">
                <span>
                  {t('domain.mitarbeiter.feiertagskonto.kontoausgleich.titel')}
                </span>
              </Body>
              <div className="flex felx-row items-baseline gap-1">
                <Heading size="lg" weight="bold">
                  {feiertagskonto.kontostand.toLocaleString('de-DE')}
                </Heading>
                <Body
                  asChild
                  size="md"
                  weight="bold"
                  className="text-labels-secondary">
                  <span>{t('domain.mitarbeiter.feiertagskonto.tage')}</span>
                </Body>
              </div>
            </CardDescription>
          </CardContent>
        </Card>
        <Card className="flex-1">
          <CardContent className="flex flex-row gap-3 justify-between items-center">
            <div className="flex flex-row gap-3">
              <div className="bg-neutrals-v2-200 w-12 h-12 rounded-xl flex justify-center items-center">
                <FontAwesomeIcon
                  icon={faArrowRightArrowLeft}
                  className="size-6"
                />
              </div>
              <CardDescription className="flex flex-col">
                <Body
                  size="sm"
                  weight="semibold"
                  className="text-labels-secondary">
                  <span>{'Übertrag aus Vorjahr'}</span>
                </Body>
                <div className="flex felx-row items-baseline gap-1">
                  <Heading size="lg" weight="bold">
                    {feiertagskonto.uebertragAusVorjahr.toLocaleString('de-DE')}
                  </Heading>
                  <Body
                    asChild
                    size="md"
                    weight="bold"
                    className="text-labels-secondary">
                    <span>{t('domain.mitarbeiter.feiertagskonto.tage')}</span>
                  </Body>
                </div>
              </CardDescription>
            </div>
            <div className="items-center">
              <UpdateUebertragAusVorjahr jahr={year} mitarbeiterId={id} />
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
